import React from "react";
import ContentLoader from "react-content-loader";


const TeamLoader = () => (
    <ContentLoader
        height={48}
        width={'100%'}
        speed={1}
        backgroundColor={'#cfd8dc'}
        foregroundColor={'#eceff1'}
    >
        {/* Only SVG shapes */}
        {/* <circle cx="10" cy="10" r="10" /> */}
        <rect x="0" y="0" rx="5" ry="5" width="48" height="48" />
        {/* <rect x="30" y="4" rx="5" ry="5" width="100" height="12" /> */}
        <rect x="56" y="12" rx="3" ry="3" width="100" height="12" />
        <rect x="56" y="30" rx="3" ry="3" width="60" height="10" />
        {/* <rect x="190" y="35" rx="5" ry="5" width="30" height="14" /> */}
    </ContentLoader>
)

export default TeamLoader